// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__f8-EQ","title":"FrontImage_title__1lSbj"};